module.exports = "images/default_okoo_square.c6c1e917.png";